/**
 * @generated SignedSource<<31fb9ae051961a6d9d5a3c7cf3514a0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionHeader$data = {
  readonly externalId: number | null;
  readonly field: {
    readonly id: string;
    readonly previousId: number | null;
  } | null;
  readonly " $fragmentType": "InspectionHeader";
};
export type InspectionHeader$key = {
  readonly " $data"?: InspectionHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FieldNode",
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previousId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};

(node as any).hash = "098b5623b7200c87f6ff0b11577c4530";

export default node;
